import { Component, OnInit } from '@angular/core';
import { MetadataApiService } from 'app/common/services/metadata-api.service';
@Component({
  standalone: false,
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.css']
})
export class NotificationMessageComponent implements OnInit {
  public data: any = {};
  public message: string = '';

  constructor(private metadataApiService: MetadataApiService) {
  }

  ngOnInit(): void {
    this.metadataApiService.getTradeMessage().subscribe((data: any) => {
      if (data.body.showMessage) {
        this.displayTradeStatusMessage(data);
      } 
    });
  }
  

  public displayTradeStatusMessage(data:any) {
    this.message = data.body.message;
  }

  public close(): void {
    this.message = '';
  }

}
